import { getCanonicalSearchUrl } from '@eventbrite/redux-destination';
import React from 'react';
import {
    FACETED_SEARCH_DROPDOWN_FILTER_PROP_MAP,
    SEO_FRIENDLY_FILTERS,
} from '../../../../constants/filters';

const seoFriendlyEventSearch = SEO_FRIENDLY_FILTERS.reduce(
    (memo: { [key: string]: string | string[] }, key: string) => {
        memo[key] = '';

        return memo;
    },
    {},
);

const removeUnlinkableValues = (
    values: { value: string; display?: string }[],
) =>
    values.filter(
        ({ value }) =>
            value &&
            ['custom_date', 'paid', 'clearPrice'].indexOf(value) === -1,
    );

const FilterLinks = ({
    values,
    filterType,
    slug,
}: {
    values: { value: string; display?: string }[];
    filterType: string;
    slug: string;
}) => {
    const filteredValues = removeUnlinkableValues(values);
    const links = filteredValues.map(({ value, display }) => {
        let formattedEventSearch = seoFriendlyEventSearch;

        if (filterType === 'tags' || filterType === 'format') {
            formattedEventSearch = {
                ...seoFriendlyEventSearch,
                tags: [...seoFriendlyEventSearch.tags, value],
            };
        } else {
            formattedEventSearch = {
                ...seoFriendlyEventSearch,
                [filterType]: value,
            };
        }

        const path = getCanonicalSearchUrl({
            ...formattedEventSearch,
            slug,
        });

        return { href: path, display };
    });

    return (
        <ul>
            {links.map(({ href, display }) => (
                <li
                    key={href}
                    style={{ marginBottom: '8px', listStyle: 'none' }}
                >
                    <a href={href}>{display}</a>
                </li>
            ))}
        </ul>
    );
};

export const BotFilters = (props: { slug: string }) => (
    <section data-testid="bot-friendly-filters">
        {SEO_FRIENDLY_FILTERS.map((filterType) => {
            const heading =
                FACETED_SEARCH_DROPDOWN_FILTER_PROP_MAP[filterType].label;
            const values =
                FACETED_SEARCH_DROPDOWN_FILTER_PROP_MAP[filterType].values;

            return (
                <div
                    key={heading.toString()}
                    data-testid="bot-friendly-filter--heading"
                >
                    <section className="eds-text-bl">{heading}</section>
                    <FilterLinks
                        values={values}
                        filterType={filterType}
                        slug={props.slug}
                    />
                </div>
            );
        })}
    </section>
);

export default BotFilters;
